export default {
    index: {
        listagem_conversao_resultado: 'Listagem de Conversão de Resultado',
        conversao_resultado_nao_encontrada: 'Nenhuma conversão de resultado encontrada',
        criar_conversao_resultado: 'Criar Conversão de Resultado',
        origem: 'Origem',
        destino: 'Destino',
        exame: 'Exame',
        editar: 'Editar'
    },
    form: {
        integracao_origem: 'Integração de Origem',
        integracao_destino: 'Integração de Destino',
        exame: 'Exame',
        operacao: 'Operação',
        operacao_descricao: 'Operação que será aplicada ao resultado. Exemplos: + 10 ou - 10 ou * 10 ou / 10',
        status_descricao: 'Status da conversão de resultado',
        titulo_editar: 'Editar Conversão de Resultado',
        titulo_criar: 'Criar Nova Conversão de Resultado',
        integracao_origem_obrigatoria: 'A seleção da integração de origem é obrigatória!',
        integracao_destino_obrigatoria: 'A seleção da integração de destino é obrigatória!',
        exame_obrigatorio: 'A seleção do exame é obrigatória!',
        regra_operacao_obrigatoria: 'No campo operação só é permitido números, vírgula e operadores básicos de matemática.',
        criada_sucesso: 'Configuração de conversão de resultado criada com Sucesso',
        editada_sucesso: 'Configuração de conversão de resultado atualizada com Sucesso'
    }
}